import { useQuery } from '@tanstack/react-query';
import { GetUserResponse } from '@/types/api/user';
import api from '@/api';

type UserQueryKey = ['users', 'current'];

export function useCurrentUserQuery() {
  return useQuery<GetUserResponse, Error, GetUserResponse, UserQueryKey>({
    queryKey: ['users', 'current'],
    queryFn: () => api.user.current(),
  });
}
